export default {
  sections: {
    order_summary: 'Order total',
  },
  labels: {
    add_items: 'Add items to get started',
    item_count_one: '{{count}} item',
    item_count_other: '{{count}} items',
  },
  buttons: {
    return: 'Back to order review',
  },
};
